import { useFormContext, Controller, ControllerProps } from "react-hook-form";

export function GenerateField(props: ControllerProps) {
  const { control } = useFormContext();

  return <Controller {...props} control={control} />;
}
